import { BaseOutput, isBaseOutput } from './base-output.model'
import { has, isString, isObject, isFinite, isBoolean } from 'lodash'

export interface Toponym {
  // eslint-disable-next-line @typescript-eslint/naming-convention
  Id: number
  // eslint-disable-next-line @typescript-eslint/naming-convention
  Toponym: string
  // eslint-disable-next-line @typescript-eslint/naming-convention
  Default: boolean
}

export interface GetAddressPrefixListOutput extends BaseOutput {
  // eslint-disable-next-line @typescript-eslint/naming-convention
  ToponymList: Toponym[]
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const isToponym = (obj: any): obj is Toponym => {
  // eslint-disable-next-line @typescript-eslint/naming-convention
  const Id = 'Id'
  // eslint-disable-next-line @typescript-eslint/naming-convention
  const Toponym = 'Toponym'
  // eslint-disable-next-line @typescript-eslint/naming-convention
  const Default = 'Default'

  return (
    isObject(obj) &&
    has(obj, Toponym) &&
    isString(obj[Toponym]) &&
    has(obj, Id) &&
    isFinite(obj[Id]) &&
    has(obj, Default) &&
    isBoolean(obj[Default])
  )
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const isGetAddressPrefixListOutput = (obj: any): obj is GetAddressPrefixListOutput => {
  // eslint-disable-next-line @typescript-eslint/naming-convention
  const ToponymList = 'ToponymList'

  return (
    isBaseOutput(obj) &&
    has(obj, ToponymList) &&
    Array.isArray(obj[ToponymList]) &&
    (!obj[ToponymList].length || isToponym(obj[ToponymList][0]))
  )
}
